import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPointV3 } from '@retailer-platform/dashboard/routing'

import { receiptsRouter } from './routing/receiptsRouter'
import { receiptsPartnerScopedRouter } from './routing/receiptsPartnerScopedRouter'

import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { receiptsAccessControl } from './access-control/receiptsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'receipts',
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [receiptsRouter],
    partnerScoped: [receiptsPartnerScopedRouter],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage in-store digital receipt pages for sites and banners',
          labelId: 'receiptsDomain.navigation.receipts',
          labelIdV3: 'receiptsDomain.navigation.receipts.v3',
          route: 'receipts-list',
          accessControl: receiptsAccessControl,
          positionNavV3: 12,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
  totem: {
    // The default IPP tool of all routes in this domain - should match the Navigation Entry in IPP UI.
    // Individual routes can override this by specifying a `tool` prop on their DomainRoute component.
    // The Totem entity itself is registered via `pnpm ipp domain register <totem-system-name>` in a follow-up.
    tool: 'receipts-dashboard-tool',
  },
}

export default definition
